import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Flex, Container, Heading } from '@chakra-ui/react';

import { useColors } from './components/colors';

import MarketplaceSelector from './components/MarketplaceSelector';
import StoreForm from './components/StoreForm';

import { createStoreApi } from 'features/stores/stores.api';

const AddStore = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { createStoreStatus, error } = useSelector((state) => state.stores);
  const { list: marketplaceOptions } = useSelector((state) => state.marketplaces);
  const { list: supplierOptions } = useSelector((state) => state.suppliers);
  const { textColor } = useColors();

  const [selectedMarketplace, setSelectedMarketplace] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    suppliers: [],
  });

  const handleMarketplaceSelect = (marketplace) => {
    setSelectedMarketplace(marketplace);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const storeData = {
        marketplace: {
          marketplaceId: selectedMarketplace
        },
        ...formData,
        suppliers: formData.suppliers.map((id, index) => ({
          supplierId: id,
          priorityRank: index + 1,
          name: supplierOptions.find((option) => option.id === id).value,
        })),
      };

      await dispatch(createStoreApi(storeData)).unwrap();

      // Redirect to stores list page
      navigate('/admin/stores');
    } catch (error) {
      // Error handling is now done in the reducer
      console.error('Failed to create store:', error);
    }
  };

  return (
    <Container maxW="container.xl" py={8} mt="50px">
      <Heading mb={8} color={textColor}>
        Connect Store
      </Heading>
      <Flex gap={8} direction={{ base: 'column', md: 'row' }}>
        <MarketplaceSelector
          selectedMarketplace={selectedMarketplace}
          onSelect={handleMarketplaceSelect}
        />
        <StoreForm
          formData={formData}
          onChange={setFormData}
          onSubmit={handleSubmit}
          selectedMarketplace={selectedMarketplace}
          isLoading={createStoreStatus === 'pending'}
          error={error}
        />
      </Flex>
    </Container>
  );
};

export default AddStore;
